import React from 'react';
import Column from '../../../components/UI/Containers/Column';
import {
  HeaderText,
  SubtitleText,
} from '../../../components/UI/Typography/PageHeader';
import IBADXLogo from '../../../assets/images/logo/logo-green-blue.svg';
import IBADXBG from '../../../assets/images/ibda-bg2.png';

const AuthView = ({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}) => {
  return (
    <section className="relative">
      <section className="col p-7 lg:p-10 border border-black/5 rounded-xl max-w-lg mx-auto mt-20 sm:m-auto gap-5 bg-white shadow-2xl shadow-black/20">
        {/* Welcome text, subtitle */}
        <Column className="items-center mb-5">
          <img src={IBADXLogo} alt="IBADX Logo" className="w-24 h-auto mb-7" />
          <HeaderText text={title} className="text-2xl" />
          <SubtitleText text={subtitle} />
        </Column>

        {/* Childrens */}
        {children}
      </section>
      <img
        src={IBADXBG}
        alt="IBADX Background"
        className="fixed object-contain left-0 bottom-0 z-[-1] items-center w-full h-[100%]"
        // className="absolute -bottom-[85px] object-cover left-0 w-full h-[80%] z-[-1]"
      />

      {/* Black opacity overlay */}
      <div className="fixed left-0 bottom-0 w-full h-[100%] bg-black/5 z-[-1]" />
    </section>
  );
};

export default AuthView;
